import React, { PropTypes as pt } from 'react';
import { connect } from 'react-redux';
import { Input } from 'incab/common';
import { getCurrentMarathonUrl, getData, getIsFormSubmitting, getRegistrationErrors } from '../selectors';
import { changeFormData, resetError } from '../actions';
import { resetPassword } from '../../portal/auth/actions';

class CmpRegistration extends React.Component {
    static propTypes = {
        onChange: pt.func.isRequired,
        data: pt.shape(),
        isFormSubmitting: pt.bool,
        errors: pt.shape().isRequired,
        resetPasswordError: pt.func.isRequired,
        onPasswordReset: pt.func.isRequired,
        marathonUrl: pt.string.isRequired,
    };

    handleEmailChange = (key, value) => {
        this.props.resetPasswordError();
        this.props.onChange(key, value);
    };

    handlePasswordReset = e => {
        e.preventDefault();
        this.props.resetPasswordError();
        this.props.onPasswordReset(this.props.data.email, this.props.marathonUrl);
    };

    render() {
        const { data, onChange, isFormSubmitting, errors } = this.props;
        const PasswordReset = <span>
            Если Вы не помните пароль, <a href="#" onClick={this.handlePasswordReset}>нажмите здесь</a>.
        </span>;
        return (
            <div>
                <Input
                    disabled={isFormSubmitting}
                    id="reg-email"
                    horizontal={false}
                    name="email"
                    label="Email"
                    value={data.email}
                    onChange={this.handleEmailChange}
                    placeholder="Email"
                    type="email"
                    error={errors.email}
                />
                <Input
                    disabled={isFormSubmitting}
                    id="reg-phone"
                    horizontal={false}
                    name="phone"
                    label="Телефон"
                    value={data.phone}
                    onChange={onChange}
                    placeholder="Телефон"
                    type="tel"
                    error={errors.phone}
                />
                {!errors.password && <Input
                    disabled={isFormSubmitting}
                    id="reg-name"
                    horizontal={false}
                    name="name"
                    label="Имя"
                    value={data.name}
                    onChange={onChange}
                    placeholder="Имя"
                    error={errors.name}
                />}

                {errors.password && <Input
                    disabled={isFormSubmitting}
                    id="reg-password"
                    horizontal={false}
                    name="password"
                    label="Пароль"
                    value={data.password}
                    onChange={onChange}
                    placeholder="Пароль"
                    error={errors.password}
                    type="password"
                    help={PasswordReset}
                />}
            </div>
        );
    }
}

const Registration = connect(
    state => ({
        data: getData(state),
        isFormSubmitting: getIsFormSubmitting(state),
        errors: getRegistrationErrors(state),
        marathonUrl: getCurrentMarathonUrl(state),
    }),

    dispatch => ({
        onChange: (key, value) => dispatch(changeFormData(key, value)),
        resetPasswordError: () => dispatch(resetError('password')),
        onPasswordReset: (email, url) => dispatch(resetPassword(email, url)),
    }),
)(CmpRegistration);

export default Registration;



// WEBPACK FOOTER //
// ./src/marathons/components/Registration.jsx